import { ordersCollection } from "@/firebase";
import storeCart from "@/store/storeCart";
import store from "@/store";
import moment from "moment";

const state = {
  orders: [], // naročila iz stališča stranke
  packages: [], // aktivna naročila s stališča trgovine
  archive: [], // zaprta naročila s stališča trgovine
  statusItems: ["0", "1", "2"],
  viewDate: 0, // privzeto časovno obdobje za omejitev pregleda naročil
};

const getters = {};

const actions = {
  getOrderInfo() {
    //console.log("=> storeOrders.getOrderInfo ACTION");
  },
  // eslint-disable-next-line
  toggleOrderCartItemDone({ commit }, payload) {
    return new Promise((resolve, reject) => {
      let tPayload = payload.item;
      Array.from(tPayload.storeCart.cart).forEach((x) => {
        if (x.cartId == payload.cid) x.done = !x.done;
      });

      ordersCollection
        .doc(tPayload.id)
        .set(tPayload, { merge: true })
        .then(() => {
          resolve(commit("editOrders", tPayload));
        })
        .catch((error) => {
          reject(console.log(error));
        });
    });
  },
  addOrder({ commit }, payload) {
    return new Promise((resolve, reject) => {
      // namesto .add je treba razbiti v referenco in potem .set, da lahko vrinemo server timestamp
      let orderRef = ordersCollection.doc();
      orderRef
        .set(payload)
        .then(() => {
          commit("addOrder", Object.assign({ id: orderRef.id }, payload));
          // nastavimo status cart items na 1, kar pomeni, da so postali del orderja
          Array.from(storeCart.state.cart).forEach((cartItem) => {
            let editedItem = Object.assign({}, cartItem, { status: 1 });
            store.dispatch("changeCartState", editedItem);
          });

          /*this.dispatch("getOrderItems", {
            client: store.state.storeClient.client.basicSettings.name,
            uid: store.state.storeAuth.user.uid,
            days: 30
          });*/
          resolve();
        })
        .catch((error) => {
          console.log(error);
          reject();
        });
    });
  },
  getOrderItems({ commit }, payload) {
    return new Promise((resolve, reject) => {
      // iskalni parametri so glede na izbrano časovno obdobje
      let fromDate, toDate;
      if (payload.days < 2000) {
        fromDate = new Date(Date.now() - 86400000 * payload.days);
        toDate = new Date(Date.now());
        state.viewDate = payload.days;
      } else {
        fromDate = new Date(moment(payload.days + "-01-01"));
        toDate = new Date(moment(payload.days + "-12-31"));
        state.viewDate = payload.days;
      }
      ordersCollection
        .where("client", "==", payload.client)
        .where("uid", "==", payload.uid)
        .where("timestamp", ">=", fromDate)
        .where("timestamp", "<=", toDate)
        .orderBy("timestamp", "asc")
        .get()
        .then((querySnapshot) => {
          let tempData = [];
          querySnapshot.forEach((doc) => {
            tempData.push(Object.assign(doc.data(), { id: doc.id }));
          });
          commit("getOrderItems", tempData);
          resolve();
        })
        .catch((error) => {
          console.log(error);
          reject();
        });
    });
  },
  getArchiveItems({ commit }, payload) {
    return new Promise((resolve, reject) => {
      if (payload.field == "orderId") {
        ordersCollection
          .where("client", "==", payload.client)
          .where("orderId", "==", payload.str)
          .where("status", "==", 3)
          .get()
          .then((querySnapshot) => {
            let tempData = [];
            querySnapshot.forEach((doc) => {
              tempData.push(Object.assign(doc.data(), { id: doc.id }));
            });
            commit("getArchiveItems", tempData);
            resolve();
          })
          .catch((error) => {
            console.log(error);
            reject();
          });
      } else if (payload.field == "all") {
        // iskalni parametri so glede na izbrano časovno obdobje
        let fromDate, toDate;
        if (payload.days < 2000) {
          fromDate = new Date(Date.now() - 86400000 * payload.days);
          toDate = new Date(Date.now());
          state.viewDate = payload.days;
        } else {
          fromDate = new Date(moment(payload.days + "-01-01"));
          toDate = new Date(moment(payload.days + "-12-31"));
          state.viewDate = payload.days;
        }
        ordersCollection
          .where("client", "==", payload.client)
          .where("timestamp", ">=", fromDate)
          .where("timestamp", "<=", toDate)
          .where("status", "==", 3)
          .orderBy("timestamp", "desc")
          .get()
          .then((querySnapshot) => {
            let tempData = [];
            querySnapshot.forEach((doc) => {
              tempData.push(Object.assign(doc.data(), { id: doc.id }));
            });
            commit("getArchiveItems", tempData);
            resolve();
          })
          .catch((error) => {
            console.log(error);
            reject();
          });
      } else {
        ordersCollection
          .where("client", "==", payload.client)
          .where(payload.field, "==", payload.str)
          .where("status", "==", 3)
          .orderBy("timestamp", "desc")
          .get()
          .then((querySnapshot) => {
            let tempData = [];
            querySnapshot.forEach((doc) => {
              tempData.push(Object.assign(doc.data(), { id: doc.id }));
            });
            commit("getArchiveItems", tempData);
            resolve();
          })
          .catch((error) => {
            console.log(error);
            reject();
          });
      }
    });
  },
  getOrderPackages({ commit }, payload) {
    if (
      Array.isArray(payload.isAdminShowPackages) &&
      payload.isAdminShowPackages.length
    ) {
      // če je v arrayu aktivnih poslovalnic kaj, potem moramo imeti drugačen query..
      // real-time listener
      ordersCollection
        .where("client", "==", payload.client)
        .where("deliveryName", "in", payload.isAdminShowPackages)
        .where("status", ">=", payload.statusFrom)
        .where("status", "<=", payload.statusTo)
        .orderBy("status", "asc")
        .orderBy("timestamp", "asc")
        .onSnapshot((snapshot) => {
          let tempData = [];
          let changeId = "";
          let action = "";
          snapshot.docChanges().forEach(
            (change) => {
              tempData.push(
                // enakovredna stavka, en bolj fensi ...change - spread operator
                //Object.assign(change.doc.data(), { id: change.doc.id })
                { ...change.doc.data(), id: change.doc.id }
              );
              if (change.type == "added") {
                action = "added";
                //console.log("ORDER: added");
              } else if (change.type === "modified") {
                action = "modified";
                //console.log("ORDER: modified");
              } else if (change.type == "removed") {
                changeId = change.doc.id;
                action = "removed";
                //console.log("ORDER: removed");
              }
            },
            (error) => {
              console.log(error);
            }
          );
          if (action == "added") {
            commit("getOrderPackages", tempData);
          } else if (action == "modified") {
            commit("setOrderPackages", tempData);
          } else if (action == "removed") {
            commit("removeDeliveredOrderPackages", changeId);
          }
        });
    } else {
      // real-time listener
      ordersCollection
        .where("client", "==", payload.client)
        .where("status", ">=", payload.statusFrom)
        .where("status", "<=", payload.statusTo)
        .orderBy("status", "asc")
        .orderBy("timestamp", "asc")
        .onSnapshot((snapshot) => {
          let tempData = [];
          let changeId = "";
          let action = "";
          snapshot.docChanges().forEach(
            (change) => {
              tempData.push(
                // enakovredna stavka, en bolj fensi ...change - spread operator
                //Object.assign(change.doc.data(), { id: change.doc.id })
                { ...change.doc.data(), id: change.doc.id }
              );
              if (change.type == "added") {
                action = "added";
                //console.log("ORDER: added");
              } else if (change.type === "modified") {
                action = "modified";
                //console.log("ORDER: modified");
              } else if (change.type == "removed") {
                changeId = change.doc.id;
                action = "removed";
                //console.log("ORDER: removed");
              }
            },
            (error) => {
              console.log(error);
            }
          );
          if (action == "added") {
            commit("getOrderPackages", tempData);
          } else if (action == "modified") {
            commit("setOrderPackages", tempData);
          } else if (action == "removed") {
            commit("removeDeliveredOrderPackages", changeId);
          }
        });
    }
  },
  // eslint-disable-next-line
  setOrderPackages({ commit }, payload) {
    return new Promise((resolve, reject) => {
      ordersCollection
        .doc(payload.id)
        .set(payload, { merge: true })
        .then(() => {
          resolve("OK");
        })
        .catch((error) => {
          console.log(error);
          reject();
        });
    });
  },
  // potrebujemo za branje enega orderja, pri preklicu naročila
  // eslint-disable-next-line
  async readOrder({ commit }, payload) {
    return new Promise((resolve, reject) => {
      ordersCollection
        .where("id", "==", payload.id)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            resolve(Object.assign(doc.data(), { id: doc.id }));
          });
        })
        .catch((error) => {
          console.log(error);
          reject();
        });
    });
  },
};

const mutations = {
  addOrder(state, payload) {
    state.orders.push(payload);
    state.orders.sort((a, b) =>
      parseInt(a.status) < parseInt(b.status) ? 1 : -1
    );
  },
  getOrderItems(state, payload) {
    state.orders = payload;
    state.orders.sort((a, b) =>
      parseInt(a.status) < parseInt(b.status) ? 1 : -1
    );
  },
  getArchiveItems(state, payload) {
    state.archive = payload;
  },
  getOrderPackages(state, payload) {
    payload.forEach((item) => {
      state.packages.push(item);
    });
    state.packages.sort((a, b) =>
      parseInt(a.status) > parseInt(b.status) ? 1 : -1
    );
  },
  setOrderPackages(state, payload) {
    payload.forEach((x) => {
      const index = state.packages.findIndex((item) => item.id == x.id);
      state.packages.splice(index, 1, x);
      // console.log("modified");
    });
    /*state.packages.sort((a, b) =>
      parseInt(a.status) > parseInt(b.status) ? 1 : -1
    );*/
  },
  removeDeliveredOrderPackages(state, payload) {
    const index = state.packages.findIndex((item) => item.id == payload);
    state.packages.splice(index, 1);
    //console.log(state.packages, "item removed.");
  },
  clearOrderPackages(state) {
    state.packages = [];
  },
  editOrders(state, payload) {
    const index = state.packages.findIndex((item) => item.id == payload.id);
    state.packages.splice(index, 1, payload);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
